import {  SectionFour, SectionOne, SectionSix, SectionThree, SectionTwo } from "../components/feature/Home";

export default function Home()
{
    return(
        <section className="">
            <SectionOne/>
            <SectionTwo/>
            <SectionThree/>
            <SectionSix/>
            <SectionFour/>
        </section>
    );
}